import React from "react";
import ButtonV2 from ".";
import { cn } from "../../../../../src/lib/utils";

export interface AcceptButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export const AcceptButton: React.FC<AcceptButtonProps> = ({
  label,
  onClick,
  disabled,
  loading,
  className,
}) => {
  return (
    <ButtonV2
      variant="outline"
      size="md"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={cn(
        "border-none bg-[#16A34A] text-white rounded-[8px]",
        "hover:bg-[color-mix(in_srgb,white_10%,#16A34A)] hover:text-white",
        "shadow-[0px_1px_2px_rgba(0,0,0,0.05)] transition-colors duration-150",
        "focus-visible:ring-[3px] focus-visible:ring-[#DCFCE7] focus-visible:ring-offset-0 focus-visible:outline-none",
        "active:opacity-60",
        className
      )}
    >
      {label}
    </ButtonV2>
  );
};